import { Component, OnInit, OnDestroy, Renderer2, ElementRef, ViewChild, HostListener, NgZone } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { finalize, Subject, Subscription } from 'rxjs';
import * as _ from 'lodash';
import { MatSidenav } from '@angular/material/sidenav';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { OrdersService, SearchState } from 'src/app/feature-modules/orders/shared/orders.service';
import { IShipTo } from 'src/app/feature-modules/orders/shared/interfaces/orders.interface';
import { TrackingModalComponent } from 'src/app/shared/modals/tracking-modal/tracking-modal.component';
import { ChangeDetectorRef } from '@angular/core';
import { DialogContentExampleDialog } from 'src/app/feature-modules/orders/components/title/title.component';
import { FilterSideNavComponent, FilterState } from '../filter-side-nav/filter-side-nav.component';
import { FilterDateRangeService } from '../../../services/filterdaterange.service';
import { filter } from 'rxjs/operators';

import { HttpResponse } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-territory-dashboard',
  templateUrl: './territory-dashboard.component.html',
  styleUrl: './territory-dashboard.component.scss'
})
export class TerritoryDashboardComponent implements OnInit, OnDestroy {

  // ViewChild References
  @ViewChild('voicePopup') voicePopupRef!: ElementRef;
  @ViewChild('micButton') micButtonRef!: ElementRef;
  @ViewChild('statusMessage') statusMessageRef!: ElementRef;
  @ViewChild('recordingIndicator') recordingIndicatorRef!: ElementRef;
  private mediaStream: MediaStream | null = null;
  @ViewChild(FilterSideNavComponent) filterSideNav!: FilterSideNavComponent;
  selectedDays: string = '90'; // Default: Past 90 days
  dateRangeSubscription: Subscription | undefined;
  fromDate: string = '';
  toDate: string = '';


  // Recording Properties
  isRecording: boolean = false;
  isExpanded: boolean = false;
  recordingTimeout: any;
  currentDownloadingId: string | null = null;

  // General Properties - Properly Aligned
  currentYear: number = new Date().getFullYear();
  showMore: boolean = false;
  showMoreTrackNumber: boolean = false;
  isListening: boolean = false;

  showStatus: boolean = false;
  statusText: string = '';
  isError: boolean = false;
  speechRecognitionSupported: boolean = false;
  isBusy: boolean = false;
  isFilterLoading: boolean = false;
  filterReturnedEmpty: boolean = false;
  searchValue: string = '';
  isSearchPerformed: boolean = false;
  getUserName: string | null = sessionStorage.getItem("username");
  speackerName: string = this.getUserName?.includes(',') ? this.getUserName.substring(this.getUserName.indexOf(',') + 1).trim() : this.getUserName || '';
  showAllItems: boolean = false;



  // Data Properties
  customers: IShipTo[] = [];
  orders: any[] = [];
  originalOrders: any[] = []; //  Keep original API data for sorting/reset
  orderlistSubscription!: Subscription;
  customerInfo: any = null; //  Store customer info separately
  shipToNumber: any;
  filterForm!: FormGroup;

  // Private Properties
  private recognition: any;
  statusTimeout: any;
  
  // Freshness indicator state (shown on 90-day cache HIT)
  cachedAt: string | null = null;
  cachedAtLabel: string = '';
  cachedAtSeverity: 'fresh' | 'aged' | 'stale' = 'fresh';

  // Refresh notification panel state (slides in from right, 60s after stale >24h data)
  showRefreshPanel: boolean = false;
  isRefreshingCache: boolean = false;
  private refreshPanelTimerHandle: any = null;
    isPolling: boolean = false;
  pollingMessage: string = '';
  pollingElapsedSec: number = 0;
  private pollingTimerHandle: any = null;



  constructor(
    public ordersService: OrdersService,
    private router: Router,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private renderer: Renderer2,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private location:Location,
    private filterDateRangeService: FilterDateRangeService,
    private ngZone: NgZone
  ) {
    this.initializeForm();
    
  }


  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

  // =============================================================================
  // Filter Side bar methods
  // =============================================================================

  openFilterSidenav() {
    if (this.filterSideNav) {
      this.filterSideNav.toggle();
    }
  }

  goBack() {
     sessionStorage.setItem('territoryViewLoading', 'true');
     this.location.back();
  }

  ngOnInit(): void {
  this.isBusy = true;
  this.cdr.detectChanges();
  const navigationState = history.state;

  if (navigationState?.shipToNumber) {
    this.shipToNumber = navigationState.shipToNumber;
    this.searchValue =  this.shipToNumber; // TODO: remove hardcoded value after testing

    // Store customer info from navigation state if available
    if (navigationState?.customerInfo) {
      this.customerInfo = navigationState.customerInfo;
    }

    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);

    this.fromDate = this.formatDateToYMD(ninetyDaysAgo);
    this.toDate = this.formatDateToYMD(today);

    setTimeout(() => {
      this.loadNonTerritoryOrderDetails();
    }, 300);
  }

  this.dateRangeSubscription = this.filterDateRangeService.dateRangeSelected$
    .subscribe((range) => {
      if (range?.startDate && range?.endDate) {
        this.fromDate = range.startDate;
        this.toDate = range.endDate;
        console.log('Date range received:', this.fromDate, this.toDate);
      }
    });
}

  // =========================
  // Form Initialization
  // =========================

  private initializeForm(): void {
    this.filterForm = this.fb.group({
      searchTerm: ['']
    });

    this.filterForm.get('searchTerm')?.valueChanges
      .subscribe((value) => {
        console.log('Typing:', value); //  for debug
        this.filterOrders();
      });
  }

  // =========================
  // Filter / Sort Search Results To Top
  // =========================

  private filterOrders(): void {
  const searchTerm =
    this.filterForm?.get('searchTerm')?.value?.toString().toLowerCase().trim() || '';

  console.log('Filtering with:', searchTerm);

  if (!this.originalOrders || this.originalOrders.length === 0) {
    this.orders = [];
    return;
  }

  if (!searchTerm) {
    this.orders = [...this.originalOrders];
    // Show freshness indicator only when viewing full unfiltered dataset
  } else {
    // Hide freshness indicator when filtering, as it only applies to unfiltered cache
    this.cachedAtLabel = '';
    
    this.orders = this.originalOrders.filter(order =>
      this.isMatch(order, searchTerm)
    );
  }

  console.log('Filtered orders:', this.orders.length);

  this.cdr.detectChanges(); //  force UI update (important)
}

  private isMatch(order: any, searchTerm: string): boolean {
    const orderNumber = order.orderNumber?.toString().toLowerCase() || '';
    const purchaseOrder = order.purchaseOrderNumber?.toString().toLowerCase() || '';

    const deliveryNumbers = (order.deliveries || [])
      .map((d: any) => (d.deliveryNumber || '').toString().toLowerCase());

    const productNumbers = (order.Products || [])
      .map((p: any) => (p.sKU || '').toString().toLowerCase());

    const proNumbers = (order.deliveries || [])
      .map((d: any) => (d.deliveryProNumber || '').toString().toLowerCase());

    return (
      orderNumber.includes(searchTerm) ||
      purchaseOrder.includes(searchTerm) ||
      deliveryNumbers.some(d => d.includes(searchTerm)) ||
      proNumbers.some(p => p.includes(searchTerm)) ||
      productNumbers.some(p => p.includes(searchTerm))
    );
  }

  private normalize(value: any): string {
    return value?.toString().toLowerCase().trim() || '';
  }

  // ✅ NEW: Navigate to Non-Territory Dashboard with ShipToNumber
  viewOrderDetails(shipToNumber: string): void {
    console.log('🔗 View Order - Navigating to Non-Territory Dashboard with ShipTo:', shipToNumber);
    
    // Ensure dates are set
    if (!this.fromDate || !this.toDate) {
      const today = new Date();
      const ninetyDaysAgo = new Date();
      ninetyDaysAgo.setDate(today.getDate() - 90);
      this.fromDate = this.formatDateToYMD(ninetyDaysAgo);
      this.toDate = this.formatDateToYMD(today);
    }
  }

  toggleSidenav(): void {
    this.isExpanded = !this.isExpanded;
  }

  onFiltersApplied(filterState: any): void {
    let startDate = '';
    let endDate = '';

    if (filterState?.orderRange?.start) {
      startDate = this.formatDateToYMD(filterState.orderRange.start);
    }
    if (filterState?.orderRange?.end) {
      endDate = this.formatDateToYMD(filterState.orderRange.end);
    }

    this.fromDate = startDate;
    this.toDate = endDate;

    this.isFilterLoading = true;
    this.isBusy = true;
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    this.loadNonTerritoryOrderDetails();
  }

  private formatDateToYMD(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // =============================================================================
  // UTILITY METHODS
  // =============================================================================

  clearSearch(): void {
    this.searchValue = '';
  }

  showClearIcon(): boolean {
    return this.searchValue.trim() !== '';
  }

  toggleShowMoreTrackNumber(): void {
    this.showMoreTrackNumber = !this.showMoreTrackNumber;
  }

  toggleShowMore(): void {
    this.showMore = !this.showMore;
  }

  showAllItemsMap: { [key: string]: boolean } = {};

  toggleViewAllItems(deliveryNumber: string): void {
    this.showAllItemsMap[deliveryNumber] = !this.showAllItemsMap[deliveryNumber];
    console.log('Delivery:', deliveryNumber, 'Expanded:', this.showAllItemsMap[deliveryNumber]);
  }

  viewAllItems(orderId: string): void {
    this.showAllItemsMap[orderId] = true;
  }

  showLessItems(orderId: string): void {
    this.showAllItemsMap[orderId] = false;
  }

  isOrderExpanded(deliveryNumber: string): boolean {
    return !!this.showAllItemsMap[deliveryNumber];
  }

  clearAllExpandedStates(): void {
    this.showAllItemsMap = {};
  }

  getFileNameById(deliveryNumber: string): void {
    if (!deliveryNumber) return;

    this.currentDownloadingId = deliveryNumber;

    this.ordersService.downloadProofOfDelivery(deliveryNumber).subscribe({
      next: (response: any) => {
        this.currentDownloadingId = null;

        const blob = response.body;
        if (blob && blob.size > 0) {
          const objectUrl = URL.createObjectURL(blob);
          window.open(objectUrl, '_blank');
          setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
        } else {
          this.snackBar.open(
            `Proof of Delivery document is empty for: ${deliveryNumber}`,
            'Close',
          { duration: 3000 }
        );
      }
    },
    error: (error: any) => {
      this.currentDownloadingId = null;

      console.error('Download error:', error);
      if (error.status === 404) {
        this.snackBar.open(
          `Proof of Delivery (POD) document is not available for delivery number: ${deliveryNumber}`,
          'Close',
          { duration: 3000 }
        );
      } else {
        this.snackBar.open(
          'Unable to download Proof of Delivery. Please try again.',
          'Close',
          { duration: 3000 }
        );
      }
    }
  });
}

  isValidNumberString(value: string): boolean {
    return !isNaN(Number(value)) && !isNaN(parseFloat(value));
  }

  isInteger(value: any): boolean {
    return Number.isInteger(Number(value)) && !isNaN(Number(value));
  }

  containsSpecialCharacters(value: string): boolean {
    const specialCharPattern = /[$%^&*'!@#]/;
    return specialCharPattern.test(value);
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContentExampleDialog, { panelClass: 'custom-dialog-container' });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  // =============================================================================
  // SEARCH FUNCTIONALITY
  // =============================================================================

  onSearch(): void {
    if (!this.searchValue || this.searchValue.trim() === '') {
      return;
    }

    if (this.containsSpecialCharacters(this.searchValue)) {
      this.snackBar.open('The search field cannot contain special characters. Please enter a valid search criterion (!,@,#,*,$, %, ^, &, \')', 'Close', { duration: 5000 });
      return;
    }
    const today = new Date();
    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(today.getDate() - 90);
    this.fromDate = this.formatDateToYMD(ninetyDaysAgo);
    this.toDate = this.formatDateToYMD(today);
    this.filterDateRangeService.setCustomDateRange(this.fromDate, this.toDate);

    this.isSearchPerformed = false;
    this.filterReturnedEmpty = false;
    this.clearAllExpandedStates();
    this.isBusy = true;
    this.cdr.detectChanges();
    this.loadNonTerritoryOrderDetails();
  }

  // =============================================================================
  // MODAL FUNCTIONALITY
  // =============================================================================

  showTrackingInfo(trackUrl: string): void {
    this.dialog.open(TrackingModalComponent, {
      panelClass: 'order-tracking',
      data: { url: trackUrl }
    });
  }

  // =============================================================================
  // loadNonTerritoryOrderDetails METHOD
  // =============================================================================

  loadNonTerritoryOrderDetails(): void {
    this.isBusy = true; 
    if (this.orderlistSubscription) {
      this.orderlistSubscription.unsubscribe();
    }

     // Reset polling state
    this.isPolling = false;
    this.pollingMessage = '';
    this.pollingElapsedSec = 0;
    this.stopPollingTimer();

    // Reset freshness/refresh panel state
    this.cachedAt = null;
    this.cachedAtLabel = '';
    this.showRefreshPanel = false;
    this.isRefreshingCache = false;
    this.clearRefreshPanelTimer();

    if (!this.isSearchPerformed) {
      this.isBusy = true;
      this.orders = [];
    }

    // ✅ Don't clear orders - keep showing existing data while loading

    this.orderlistSubscription = this.ordersService.FetchOrdersForNonTerrotory(this.searchValue, this.fromDate, this.toDate)
      .pipe(
        finalize(() => {
          this.isBusy = false;
          this.isFilterLoading = false;
          if (this.cdr) this.cdr.detectChanges();
        })
      )
      .subscribe({
         next: (state: SearchState) => {
                if (state.kind === 'polling') {
                  this.isBusy = false;
                  this.isFilterLoading = false;
        
                  if (!this.isPolling) {
                    this.pollingElapsedSec = Math.floor(state.elapsedMs / 1000);
                    this.isPolling = true;
                    this.pollingMessage = state.message;
                    this.startPollingTimer();
                  }
        
                  this.cdr.detectChanges();
                } else if (state.kind === 'data') {
                  this.isBusy = false;
                  this.isFilterLoading = false;
                  this.isPolling = false;
                  this.stopPollingTimer();
                  this.isSearchPerformed = true;
        
                  // Handle freshness indicator (only present for 90d cache HITs)
                  if (state.cachedAt) {
                    this.cachedAt = state.cachedAt;
                    const { label, severity } = this.computeCacheFreshness(state.cachedAt);
                    this.cachedAtLabel = label;
                    this.cachedAtSeverity = severity;
        
                    // Schedule refresh panel for stale data (>24h old)
                    if (severity === 'stale') {
                      this.scheduleRefreshPanel();
                    }
                  } else {
                    this.cachedAt = null;
                    this.cachedAtLabel = '';
                  }
        
                  if (this.ordersService.orderDetails?.orders?.length > 0) {
                    this.orders = _.cloneDeep(this.ordersService.orderDetails.orders);
                    this.orders = _.orderBy(this.orders, ['orderCreationDate'], ['desc']);
                    this.originalOrders = [...this.orders];
                    this.customerInfo = this.orders[0];
                    
                    // Reset search form BEFORE filterOrders to ensure cachedAtLabel is not cleared
                    this.filterForm.get('searchTerm')?.setValue('', { emitEvent: false });
                    
                    this.filterOrders();
                    this.filterReturnedEmpty = this.orders.length === 0;
                    setTimeout(() => {
                         const content = document.querySelector('.orders-container');
                    if (content) 
                    {
                     content.scrollTo({
                     top: 0,
                      behavior: 'smooth'
                     });
                     }
                    }, 100);
                    this.filterReturnedEmpty = false;
                  } else {
                    this.orders.splice(1);
                    this.originalOrders = [];
                    this.customerInfo = null
                    this.filterReturnedEmpty = true;
                    this.snackBar.open(
                      `No orders were found for the selected date range (${this.fromDate} to ${this.toDate}).\nUse the Filter option to expand your date range`,
                      'Close',
                      { duration: 10000, panelClass: ['multiline-snackbar'] },
                    );
                  }
                  this.cdr.detectChanges();
                } else if (state.kind === 'timeout') {
                  this.isBusy = false;
                  this.isFilterLoading = false;
                  this.isPolling = false;
                  this.stopPollingTimer();
                  this.snackBar.open(
                    'Loading is taking longer than expected. Please try again in a few minutes.',
                    'Close',
                    { duration: 10000 },
                  );
                  this.cdr.detectChanges();
                }
              },
              error: (error: any) => {
                this.isBusy = false;
                this.isFilterLoading = false;
                this.isPolling = false;
                this.stopPollingTimer();
                this.orders = [];
                console.error('Error loading orders:', error);
                this.snackBar.open("Something went wrong. Please try again.", 'Close');
              }
            });
  }



     deliveryMatchesProduct(delivery: any, product: any): boolean {
    if (!delivery || !product) return false;
    if (!product.orderLineNum) return false;

    return (delivery.orderLineNumRef || []).some(
      (ref: any) => ref.orderLineNum === product.orderLineNum
    );
  }

     getProductsForDelivery(orderinfo: any, delivery: any): any[] {
    if (!orderinfo?.Products) return [];
    
    const filtered = orderinfo.Products.filter(
      (product: any) => this.deliveryMatchesProduct(delivery, product)
    );

    // Deduplicate products by SKU
    const seen = new Set<string>();
    return filtered.filter((product: any) => {
      const key = product.sKU || `${product.productName}_${product.orderLineNum}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

   deduplicateOrderProducts(orders: any[]): any[] {
    return orders.map(order => {
      if (!order.Products || order.Products.length === 0) return order;
      
      const seen = new Set<string>();
      order.Products = order.Products.filter((product: any) => {
        // Use SKU as the primary unique identifier
        const key = product.sKU || `${product.productName}_${product.orderLineNum}`;
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
      
      return order;
    });
  }
  // =============================================================================
  // LIFECYCLE METHODS
  // =============================================================================

  ngOnDestroy(): void {
    if (this.recognition && this.isListening) {
      this.recognition.stop();
    }

    if (this.statusTimeout) {
      clearTimeout(this.statusTimeout);
    }

    if (this.recordingTimeout) {
      clearTimeout(this.recordingTimeout);
    }

    if (this.orderlistSubscription) {
      this.orderlistSubscription.unsubscribe();
    }

    if (this.dateRangeSubscription) {
      this.dateRangeSubscription.unsubscribe();
    }

     // Cleanup timers for polling and refresh panel
    this.stopPollingTimer();
    this.clearRefreshPanelTimer();
  }
   private startPollingTimer(): void {
     this.stopPollingTimer();
 
     this.pollingTimerHandle = setInterval(() => {
       if (this.isPolling) {
         this.pollingElapsedSec++;
         this.cdr.detectChanges();
       }
     }, 1000);
   }

    private clearRefreshPanelTimer(): void {
    if (this.refreshPanelTimerHandle) {
      clearTimeout(this.refreshPanelTimerHandle);
      this.refreshPanelTimerHandle = null;
    }
  }
 
   private stopPollingTimer(): void {
     if (this.pollingTimerHandle) {
       clearInterval(this.pollingTimerHandle);
       this.pollingTimerHandle = null;
     }
   }
 
   // =============================================================================
   // FRESHNESS INDICATOR + REFRESH NOTIFICATION PANEL (for 90-day cache aging)
   // =============================================================================
 
   /**
    * Computes the "last updated" label and severity based on cache age.
    *   - fresh:  <1 hour old  (green chip)
    *   - aged:   1-24 hours   (gray chip)
    *   - stale:  >24 hours    (yellow chip, triggers refresh panel after 60s)
    */
   private computeCacheFreshness(cachedAtIso: string): {
     label: string;
     severity: 'fresh' | 'aged' | 'stale';
   } {
     const cachedAtMs = new Date(cachedAtIso).getTime();
     const ageMs = Date.now() - cachedAtMs;
     const ageMinutes = Math.floor(ageMs / (60 * 1000));
     const ageHours = Math.floor(ageMs / (60 * 60 * 1000));
     const ageDays = Math.floor(ageMs / (24 * 60 * 60 * 1000));
 
     let label: string;
     let severity: 'fresh' | 'aged' | 'stale';
 
     if (ageMinutes < 1) {
       label = 'Just updated';
       severity = 'fresh';
     } else if (ageMinutes < 60) {
       label = `Last Updated ${ageMinutes} minute${ageMinutes > 1 ? 's' : ''} ago`;
       severity = 'fresh';
     } else if (ageHours < 24) {
       label = `Last Updated ${ageHours} hour${ageHours > 1 ? 's' : ''} ago`;
       severity = 'aged';
     } else {
       label = `Last Updated ${ageDays} day${ageDays > 1 ? 's' : ''} ago`;
       severity = 'stale';
     }
 
     return { label, severity };
   }
 
   /**
    * Schedules the refresh panel to slide in 45 seconds after loading stale
    * data. Backend refresh (30-40s typical) should be done by then; user can
    * click Refresh to pull the fresh data.
    */
   private scheduleRefreshPanel(): void {
     this.clearRefreshPanelTimer();
 
     this.ngZone.runOutsideAngular(() => {
       this.refreshPanelTimerHandle = setTimeout(() => {
         this.ngZone.run(() => {
           this.showRefreshPanel = true;
           this.cdr.detectChanges();
         });
       }, 45000);
     });
    }
 
   /**
    * User clicked the X to dismiss the refresh panel.
    * Panel disappears; won't return unless user does a new search on stale data.
    */
   dismissRefreshPanel(): void {
     if (this.isRefreshingCache) return;  // don't dismiss while refresh is in flight
     this.showRefreshPanel = false;
     this.cdr.detectChanges();
   }
 
   /**
    * Handler for the "Refresh" button click inside the sliding panel.
    * Silently refetches the current search:
    *   - If new data has newer cachedAt: swap in with success toast, hide panel
    *   - If cachedAt is same (backend still processing): show "still updating"
    *     toast, keep panel visible so user can try again
    */
   onRefreshPanelClick(): void {
     if (this.isRefreshingCache) return;
 
     this.isRefreshingCache = true;
     this.cdr.detectChanges();
 
     const previousCachedAt = this.cachedAt;
 
     this.ordersService.FetchOrdersForNonTerrotory(
       this.searchValue,
       this.fromDate,
       this.toDate,
     ).subscribe({
       next: (state: SearchState) => {
         if (state.kind === 'data' && state.cachedAt) {
           if (state.cachedAt !== previousCachedAt) {
             // Fresh data arrived — swap it in and hide panel
             if (this.ordersService.orderDetails?.orders?.length > 0) {
               this.orders = _.cloneDeep(this.ordersService.orderDetails.orders);
               this.orders = _.orderBy(this.orders, ['orderCreationDate'], ['desc']);
             }
 
             this.cachedAt = state.cachedAt;
             const { label, severity } = this.computeCacheFreshness(state.cachedAt);
             this.cachedAtLabel = label;
             this.cachedAtSeverity = severity;
 
             this.showRefreshPanel = false;
             this.isRefreshingCache = false;
 
             this.snackBar.open('Data refreshed with latest information.', 'Close', {
               duration: 3000,
             });
             this.cdr.detectChanges();
           } else {
             // Backend still processing — keep panel visible, notify user
             this.isRefreshingCache = false;
             this.snackBar.open(
               'Still updating. Please search again in a moment.',
               'Close',
               { duration: 4000 },
             );
             this.cdr.detectChanges();
           }
         } else {
           this.isRefreshingCache = false;
           this.cdr.detectChanges();
         }
       },
       error: () => {
         this.isRefreshingCache = false;
         this.snackBar.open('Refresh failed. Please try again.', 'Close', {
           duration: 3000,
         });
         this.cdr.detectChanges();
       },
     });
   }
}
